import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  headers: {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
});

// Attach admin token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("archdigital_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["X-Admin-Token"] = token;
  }
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = {
      ...(config.params || {}),
      _ts: Date.now(),
    };
  }
  return config;
});
